import * as THREE from 'three';

const morphFaceComponent = {
  schema: {
    src: { type: 'string', default: '' },
    roughness: { type: 'number', default: 1 },
    metalness: { type: 'number', default: 0 },
    color: { type: 'string', default: '' },
    opacity: { type: 'number', default: 1 },
  },
  init: function () {
    const el = this.el;
    const textureSrc = this.data.src;
    const color = this.data.color;
    const opacity = this.data.opacity;
    el.addEventListener('model-loaded', () => {
      const mesh = el.getObject3D('mesh');
      if (!mesh) return;

      mesh.traverse(node => {
        if (node.isMesh) {
          this.mesh = node;
          const texture = new THREE.TextureLoader().load(textureSrc);
          node.material = new THREE.MeshStandardMaterial({
            map: texture,
            color: color, // red tint
            roughness: 0.8,
            metalness: 0.2,
            side: THREE.DoubleSide,
            transparent: true,
            opacity: opacity,
          });

          // Important: update matrix if needed
          node.material.map.needsUpdate = true;

          if (!(node.geometry instanceof THREE.BufferGeometry)) {
            node.geometry = new THREE.BufferGeometry().fromGeometry(
              node.geometry
            );
          }
        }
      });
    });
  },

  updatePosition(position) {
    if (!this.mesh) return;

    const pos = this.mesh.geometry.attributes.position;

    pos.array.set(position);
    pos.needsUpdate = true;
    this.mesh.geometry.computeBoundingSphere();
  },
};

export { morphFaceComponent };
